module.exports = __webpack_public_path__ + "static/media/quick-search-active.dc8b8445.svg";